import React, { useState } from 'react'
import styles from './HeroSection.module.scss'
// import mainImg from '@assets/img/mainImg.png'
import meituanIcon from '@assets/img/meituanLogo.png'
import dianpingIcon from '@assets/img/dianpingLogo.png'
import sendImage from '@assets/img/send.png'
import cardLogo1 from '@assets/img/floatingCard1Logo.png'
import cardLogo2 from '@assets/img/floatingCard2Logo.png'
import cardLogo3 from '@assets/img/floatingCard3Logo.png'
import { withTranslator } from '@common/hoc/translatorHoc'
import { WithI18nProps } from '@/types/i18n'
import { createMerchantI18n, getLocaleStyleClass } from '@/utils/i18n'

interface HeroProps {
  onJoin: () => void
}

const HERO_VIDEO_SRC =
  'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/redpandacompress_redpandacompress_%E8%A7%86%E9%A2%91.mp4'
const HERO_VIDEO_FALLBACK_IMG =
  'https://s3plus-shon.meituan.net/overseas-merchant/merchant-home/%E5%AE%B9%E5%99%A8%20433638%401x.png'

const HeroSection: React.FC<HeroProps & WithI18nProps> = ({ onJoin, i18n }) => {
  const t = React.useMemo(() => createMerchantI18n(i18n), [i18n])
  const [videoLoaded, setVideoLoaded] = useState(false)

  const  getCurrentLanguage = () => {
    if (!i18n) return 'zh-CN';
    return i18n.getLocale() || 'zh-CN';
  };

  const getCurrentLanguageClass = (style: string): string => {
    return getLocaleStyleClass(getCurrentLanguage(), style)
  }

  return (
    <section className={styles.hero}>
      <div className={styles.heroContent}>
        <div className={styles.heroHeader}>
          <div className={styles.headerItem}>
            <img src={meituanIcon} alt="meituan" />
            <span className={styles.meituanText}>{t('meituan', "美团")}</span>
          </div>
          <div className={styles.headerItem}>
            <img src={dianpingIcon} alt="dianping" />
            <span>{t('dianping', "大众点评")}</span>
          </div>
        </div>
        <div className={styles.heroContentText}>{t('cooperationTitle', "增加店铺线上曝光")}</div>
        <div className={styles.heroContentText}>{t('cooperationDescription', "吸引更多游客进店消费")}</div>
        <div className={styles.heroButton} onClick={onJoin}>
          <span>{t('wantToJoin', "我要入驻")}</span>
          <img src={sendImage} alt="send" />
        </div>
      </div>
      {/* 悬浮的 card 容器 */}
      <div className={styles.floatingCardContainer}>
        <div className={`${styles.floatingCard} ${styles[getCurrentLanguageClass('FloatingCard')]}`}>
          <div className={`${styles.floatingCardTitle} ${styles[getCurrentLanguageClass('FloatingCardTitle')]}`}>
            <img src={cardLogo1} alt="cardLogo1" />
            <span className={styles.specialText}>
              {t('userScaleSpecialText', "海量")}
            </span>
            <span>
              {t('userScaleNormalText', "优质用户")}
            </span>
          </div>
          <div className={`${styles.floatingCardContent} ${styles[getCurrentLanguageClass('FloatingCardContent')]}`}>
            <span>
              {t('userScaleDescription', "美团+大众点评双平台，")}
            </span>
            <span className={styles.specialText}>
              {t('userScaleSpecialDescription', "覆盖7.7亿年度交易用户")}
            </span>
          </div>
        </div>

        <div className={`${styles.floatingCard} ${styles[getCurrentLanguageClass('FloatingCard')]}`}>
          <div className={`${styles.floatingCardTitle} ${styles[getCurrentLanguageClass('FloatingCardTitle')]}`}>
            <img src={cardLogo2} alt="cardLogo1" />
            <span className={styles.specialText}>
              {t('closedLoopSceneSpecialText', "全链路")}
            </span>
            <span>
              {t('closedLoopSceneNormalText', "闭环场景")}
            </span>
          </div>
          <div className={`${styles.floatingCardContent} ${styles[getCurrentLanguageClass('FloatingCardContent')]}`}>
            <span>
              {t('closedLoopSceneDescription', "行程规划→实时搜索→线上预订→到店消费的全链路闭环，")}
            </span>
            <span className={styles.specialText}>
              {t('closedLoopSceneSpecialDescription', "用户体验好，决策效率高")}
            </span>
          </div>
        </div>

        <div className={`${styles.floatingCard} ${styles[getCurrentLanguageClass('FloatingCard')]}`}>
          <div className={`${styles.floatingCardTitle} ${styles[getCurrentLanguageClass('FloatingCardTitle')]}`}>
            <img src={cardLogo3} alt="cardLogo1" />
            <span className={styles.specialText}>
              {t('dataDrivenSpecialText', "精准")}
            </span>
            <span>
              {t('dataDrivenNormalText', "数据驱动")}
            </span>
          </div>
          <div className={`${styles.floatingCardContent} ${styles[getCurrentLanguageClass('FloatingCardContent')]}`}>
            <span>
              {t('dataDrivenDescription', "基于用户行为偏好智能推荐，")}
            </span>
            <span className={styles.specialText}>
              {t('dataDrivenSpecialDescription', "需求匹配精准，交易转化率高")}
            </span>
          </div>
        </div>

      </div>
      <div className={styles.backgroundImg}>
        {!videoLoaded && (
          <img
            src={HERO_VIDEO_FALLBACK_IMG}
            alt=""
            className={styles.heroFallbackImage}
          />
        )}
        <video
          src={HERO_VIDEO_SRC}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          className={`${styles.heroVideo} ${videoLoaded ? styles.heroVideoVisible : styles.heroVideoHidden}`}
          onLoadedData={() => setVideoLoaded(true)}
        />
      </div>
    </section>
  )
}

export default withTranslator(HeroSection)

